<template>
  <transition name="modal">
    <div id="ecommerce_product_edit" class="modal-mask" @click="$emit('close')">
      <div class="modal-wrapper" role="document" style="overflow-y:auto;position:absolute">
        <div class="modal-container modal-dialog">
          <div class="modal-content" @click.stop>
            <div class="modal-header">
              <div class="row">
                <div class="col-xs-10">
                  <ul style="margin:0;padding:0">
                    <li
                      style="display:inline-block"
                      role="presentation"
                      @click="currentView = 'product'"
                    >
                      <a
                        class="btn"
                        :class="{
                          'btn-primary': currentView == 'product',
                          'btn-default': currentView != 'product'
                        }"
                        href="javascript:void(0);"
                        >Edit Product</a
                      >
                    </li>
                  </ul>
                </div>
                <div class="col-xs-2">
                  <button
                    type="button"
                    class="close"
                    @click="$emit('close')"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <vue-simple-svg
                      :filepath="'/static/img/assets/_global/Close.svg'"
                      width="50px"
                      height="auto"
                      class="icon"
                    />
                  </button>
                </div>
              </div>
            </div>
            <template v-if="currentView == 'product'">
              <div class="modal-body">
                <template v-if="product">
                  <div class="row">
                    <div class="col-xs-12">
                      <div class="form-group" :class="{ 'has-error': errors.has('categoryInput') }">
                        <label for="categoryInput">Category *</label>
                        <select-category
                          :pageid="pageid"
                          v-model="category"
                          :selected="currentCategory"
                          @onChangeCategory="onChangeCategory"
                          data-vv-name="categoryInput"
                          data-vv-as="Category"
                          v-validate="'required'"
                        ></select-category>
                        <p class="text-error" v-show="errors.has('categoryInput')">
                          {{ errors.first('categoryInput') }}
                        </p>
                      </div>

                      <!--<div class="form-group">
												<label for="subCategoryInput">Sub Category</label>
												<select name="subCategory" class="form-control"  v-model="product.subcategoryid">
													<option value="0" :selected="product.subcategoryid == 0">Select Sub-Category</option>
													<template v-if="currentCategory">
														<option :value="subcategory.id" v-for="(subcategory,index) in currentCategory.subcategories" :selected="subcategory.id == product.subcategoryid" :key="'subcategory_'+index">{{ subcategory.name }}</option>
													</template>
												</select>
											</div>-->
                    </div>
                    <div class="col-xs-12">
                      <div
                        class="pb-3"
                        style="padding-top:15px;"
                        :class="{ 'has-error': errors.has('uploadMultipleFile') }"
                      >
                        <!-- <uploadfile v-model="product.photourl"></uploadfile> -->
                        <upload-multiple-file
                          v-model="productImages"
                          :max="3"
                          data-vv-name="uploadMultipleFile"
                          data-vv-as="Preview Image"
                          v-validate="'required'"
                        ></upload-multiple-file>

                        <p class="text-error" v-show="errors.has('uploadMultipleFile')">
                          {{ errors.first('uploadMultipleFile') }}
                        </p>
                      </div>
                    </div>

                    <div class="col-xs-12">
                      <div class="form-group" :class="{ 'has-error': errors.has('nameInput') }">
                        <label for="nameInput">Name *</label>
                        <input
                          type="text"
                          class="form-control"
                          ref="name"
                          id="nameInput"
                          name="nameInput"
                          data-vv-as="Name"
                          aria-describedby="name"
                          placeholder="Name"
                          v-model="product.name"
                          v-validate="'required'"
                        />
                        <p class="text-error" v-show="errors.has('nameInput')">
                          {{ errors.first('nameInput') }}
                        </p>
                      </div>

                      <div
                        class="form-group"
                        :class="{ 'has-error': errors.has('descriptionInput') }"
                      >
                        <label for="nameInput">Product Detail *</label>
                        <textarea
                          type="text"
                          class="form-control"
                          id="descriptionInput"
                          style="resize:vertical"
                          name="descriptionInput"
                          data-vv-as="Description"
                          aria-describedby="description"
                          placeholder="Description"
                          row="3"
                          v-model="product.description"
                          v-validate="'required'"
                        ></textarea>
                        <p class="text-error" v-show="errors.has('descriptionInput')">
                          {{ errors.first('descriptionInput') }}
                        </p>
                      </div>

                      <div class="form-group" :class="{ 'has-error': errors.has('tags') }">
                        <label for="keywordInput">Keywords *</label>
                        <vue-tags-input
                          v-model="tag"
                          :tags="tags"
                          @tags-changed="newTags => (tags = newTags)"
                          @before-adding-tag="checkTag"
                        />
                        <input
                          type="hidden"
                          v-model="tags"
                          name="tags"
                          data-vv-as="Keyword"
                          v-validate="'required'"
                        />
                        <p class="text-error" v-show="errors.has('tags')">
                          {{ errors.first('tags') }}
                        </p>
                      </div>
                      <!-- <div class="text-center">
												<a class="text" href="javascript:void(0);" @click="showAdvanced = !showAdvanced">Advanced <i class="fa " :class="{'fa-angle-down' : showAdvanced , 'fa-angle-up' : !showAdvanced}"></i></a>
											</div> -->

                      <template>
                        <hr />

                        <div class="form-group">
                          <label for="buttonActionInput">Button Action</label>
                          <select
                            name="buttonAction"
                            class="form-control"
                            v-model="product.buttonaction"
                          >
                            <!-- <option value="none">None</option> -->
                            <option value="url">Url</option>
                            <!-- <option value="buy">Buy</option> -->
                          </select>
                        </div>

                        <div
                          class="form-group"
                          v-if="product.buttonaction == 'url' || product.buttonaction == 'buy'"
                        >
                          <label for="buttonNameInput">Button Name</label>
                          <p>Location</p>
                        </div>

                        <div
                          class="form-group"
                          v-if="product.buttonaction == 'url'"
                          :class="{ 'has-error': errors.has('buttonUrlInput') }"
                        >
                          <label for="buttonUrlInput">Button Url *</label>
                          <input
                            type="text"
                            class="form-control"
                            id="buttonUrlInput"
                            name="buttonUrlInput"
                            aria-describedby="Button Url"
                            data-vv-as="Button Url"
                            placeholder="Button Url"
                            v-model="product.buttonurl"
                            v-validate="'required'"
                          />
                          <p class="text-error" v-show="errors.has('buttonUrlInput')">
                            {{ errors.first('buttonUrlInput') }}
                          </p>
                        </div>
                      </template>

                      <div class="text-center" style="margin-top: 15px">
                        <a href="javascript:void(0);" @click="onDeleteProduct(product.id)"
                          >Delete Product</a
                        >
                      </div>
                    </div>
                  </div>
                </template>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-primary" @click="saveProduct">Save</button>
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="$emit('close')"
                >
                  Close
                </button>
              </div>
            </template>
            <template v-else>
              <product-stock
                v-model="product"
                @close="$emit('close')"
                @saveStock="saveStock"
              ></product-stock>
            </template>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import SelectCategory from './SelectCategory'
import uploadfile from '@/components/elements/uploadfile'
import api from '@/api'
import VueTagsInput from '@johmun/vue-tags-input'
import UploadMultipleFile from '@/components/elements/UploadMultipleFile'
import ProductStock from './ProductStock'

export default {
  props: ['value', 'category'],
  data: function() {
    return {
      productImages: [],
      product: this.value,
      currentCategory: this.value.categoryid,
      categories: null,
      tag: '',
      currentView: 'product',
      showAdvanced: false
    }
  },
  computed: {
    currencySign: function() {
      if (this.product && this.product.currency) {
        switch (this.product.currency.toUpperCase()) {
          case 'THB':
            return '฿'
          case 'MMK':
            return 'K'
          case 'GBP':
            return '£'
          default:
            return '$'
        }
      }
      return '$'
    },
    pageid: function() {
      return this.$store.state.selectedBot.pageid
    },
    tags: {
      get() {
        let vm = this
        if (vm.product.keyword != '') {
          var tags = vm.product.keyword.split(',')
          var result = []
          $.each(tags, function(index, val) {
            result.push({ text: val })
          })
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        $.each(value, function(index, val) {
          result.push(val.text)
        })
        vm.product.keyword = result.join(',')
      }
    }
  },
  components: {
    SelectCategory,
    uploadfile: uploadfile,
    VueTagsInput,
    UploadMultipleFile,
    ProductStock
  },
  mounted: function() {
    let vm = this
    vm.productImages = vm.product.photourl.split(';;')
    vm.currentCategory = vm.product.categoryid
    this.$refs.name.focus()

    document.addEventListener('keydown', e => {
      if (e.keyCode == 27) {
        vm.$emit('close')
      }
    })
  },
  methods: {
    onChangeCategory: function(payload) {
      this.currentCategory = payload
    },
    saveProduct: function() {
      let vm = this
      vm.$validator.validate().then(result => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        let product = vm.product
        product.pageid = vm.pageid
        product.photourl = vm.productImages.join(';;')
        product.categoryid = vm.currentCategory
        vm.$store.dispatch('loading')
        api.editProduct(product, function(error, response) {
          vm.$store.dispatch('loading')
          vm.$emit('input', product)
          vm.$emit('close')
        })
      })
    },
    saveStock: function() {
      this.currentView = 'product'
      this.$emit('close')
    },
    checkTag: function(obj) {
      // if (obj.tag.text.includes(',')) alert('Letter "," is forbidden');
      // else
      obj.addTag()
    },
    onDeleteProduct: function(id) {
      if (confirm('Do you want to delete this?')) {
        let vm = this
        vm.$store.dispatch('loading')
        api.deleteProduct(id, function(error, response) {
          if (error) {
            console.error(error)
            vm.$store.dispatch('loading')
            return
          }

          vm.$emit('productDeleted')
          vm.$emit('close')
          vm.$store.dispatch('loading')
        })
      }
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      this.product = this.value
      let vm = this
      vm.productImages = vm.product.photourl.split(';;')
    },
    category: function(newVal, oldVal) {
      let vm = this
    },
    'product.price': function(newVal, oldVal) {
      this.product.discountprice = newVal
    }
  }
}
</script>

<style scroped></style>



// WEBPACK FOOTER //
// src/components/view/template/event/ModalEditProduct.vue